import MessageRecords from './MessageRecords';
import Pagination from '../Pagination';
import React, { useState, useEffect } from "react";

export const MessageTable = ({data}) => {

    const [msgs, setMsgs] = useState([]);

    // User is currently on this page
    const [currentPage, setCurrentPage] = useState(1);// No of Records to be displayed on each page   
    const [recordsPerPage] = useState(5);
  
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = msgs.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(msgs.length / recordsPerPage)
    
    useEffect(() => {
        setMsgs(data);
    }, [data]) 

  return (
    <>
        <MessageRecords data={currentRecords}/>
                <Pagination
                    nPages={nPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
        />
    </>
  )
}
